import React from "react";
import { Colors, MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import styled from "styled-components";
import CustomButton from "../custom-button"; // Adjust import as needed
import Box, { FlexDirection } from "../../box";
import "./styles.css"; 

// const FilledSelect = styled(Select.ofType<{ label: string; value: string }>())`
//   .bp5-popover-target {
//     width: 100%;
//   }
// `;
const FilledSelect = Select.ofType<ItemType>();
// const SelectWrapper = styled.div`
//   .bp5-popover-target {
//     width: "100%";
//   }
// `;

export type ItemType = { label: string; value: string };

interface CustomSelectProps {
  className?: string;
  errorClassName?: string;
  flexDir?: FlexDirection;
  title?: string;
  label?: string;
  labelFontSize?: string;
  isActiveItem: boolean;
  items: ItemType[];
  values: string[];
  onSelect: (value: ItemType) => void;
	disabled?:boolean;
	filterable?:boolean;
	disabledButton?:boolean;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  className,
  errorClassName,
  flexDir="col",
  title,
  label,
  labelFontSize,
  isActiveItem,
  items,
  values,
  onSelect,
	disabled = false,
	filterable = false,
	disabledButton = false,

}) => {
  return (
    <>
      <div className={flexDir == "row"? "display-flex align-center": ""}>
        {title ? <Label>{title}</Label>:null} 
        <FilledSelect
        
          className={className}
          activeItem={
            isActiveItem
              ? items.find((item) =>
                  item.value ? values.includes(item.value) : null
                )
              : null
          }
          filterable={filterable}
          items={items}
          onItemSelect={(item, event) => {
            if (event) event.stopPropagation();
            onSelect(item);
          }}
          popoverProps={{
            minimal: true,
            targetProps: { style: { width: "100%" } },
            popoverClassName: "custom-select limit-popover-height",
           
          }}
          itemRenderer={(item: ItemType, { modifiers, handleClick }) => (
            <MenuItem
              active={modifiers.active}
              text={item.label}
              key={item.value}
              onClick={handleClick}
            />
          )}
					disabled={disabled}
        >
          <CustomButton
            fontSize={labelFontSize}
            alignText="left"
            text={label ?? "Select "}
            endIcon="caret-down"
            bradius="5px"
            width="100%"
            className={errorClassName}
            disabled={disabledButton}
          />
        </FilledSelect>
      </div>
    </>
  );
};

export default CustomSelect;


const Label = styled.span`
    font-size: 15px;
    margin-right: 10px;
    color: ${({ theme: { darkMode } }) =>darkMode ? Colors.GRAY5 : Colors.GRAY1};
`;